import { Box, Text } from '@mantine/core'

export interface UserDisplayData {
  display: string
  name: string
  email: string
}

export interface UserDisplayProps {
  user: UserDisplayData
  showDetailedView?: boolean
}

/**
 * Component for displaying user information with conditional detailed view.
 * Shows name and email on separate lines when showDetailedView is true and both values exist,
 * otherwise falls back to the display value.
 */
export function UserDisplay({ user, showDetailedView = false }: UserDisplayProps) {
  const shouldShowDetailed = showDetailedView && user.name && user.email

  if (shouldShowDetailed) {
    return (
      <Box style={{ maxWidth: '100%', overflow: 'hidden', lineHeight: 1.3 }} role="group" aria-label="User details">
        <Text size="sm" fw={500} truncate aria-label={`Name: ${user.name}`}>
          {user.name}
        </Text>
        <Text size="sm" fw={500} c="dimmed" truncate aria-label={`Email: ${user.email}`}>
          {user.email}
        </Text>
      </Box>
    )
  }

  return (
    <Text truncate title={user.display} style={{ maxWidth: '100%' }} aria-label={`User: ${user.display}`}>
      {user.display}
    </Text>
  )
}
